<div class="c-card">
	<div class="c-content u-no-p@up-to-md">
		<table-therapy-fund-wallets [(wallets)]="vm.wallets" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></table-therapy-fund-wallets>
	</div>
	<div *ngIf="vm.wallets && vm.wallets?.length > vm.pageSize">	
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.wallets?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
